import AcceleratedTesters from './AcceleratedTesters.container';

export default AcceleratedTesters;
